import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
export const myCaseloadApi = createApi({
    reducerPath: 'myCaseloadApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/task_plans",
    }),
    tagTypes: ["MyCaseload"],
    endpoints: (builder) => ({
        getCaseloadData: builder.query({
            query: () => ({
                method: "GET",
                url: `/task_casloads`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["MyCaseload"]
        }),

        favouriteTaskPlan: builder.mutation({
            query: ({ data, id }) => ({
                method: "POST",
                url: `/favorite/${id}`,
                data: data
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["MyCaseload"]
        }),

        getAchievementData: builder.query({
            query: () => ({
                method: "GET",
                url: `/my_achievements`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["MyCaseload"]
        }),


    }),
})

export const {
    useFavouriteTaskPlanMutation,
    useGetCaseloadDataQuery,
    useGetAchievementDataQuery
} = myCaseloadApi;